import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'
import Table from '@tables/table'

class UserActionLogDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'UserActionLogDialog')
        }
    }

    state = {
        dialogOpen: false,
        validAction: ['bet', 'rebet', 'rollback', 'withdrawFaild', 'cancel_bet'],
        BetFailed: ['rollback', 'withdrawFaild', 'cancel_bet']
    }

    columns = [
        {
            field: 'time',
            type: 'datetime',
            cusSort: true
        },
        {
            field: 'action',
            render: (rowData) => {
                const display = this.t(rowData.action)
                /** Aviator顯示邏輯 */
                const extraBet = rowData.info?.is_extra_bet ? '★' : ''
                return this.state.BetFailed.includes(rowData.action) ? <div style={{ color: '#f00' }}>{`${display}${extraBet}`}</div> : `${display}${extraBet}`
            },
        },
        {
            field: 'money',
            type: 'currency',
            render: (rowData) => {
                const display = utils.currencyFormatter(rowData['info']['money'], this.props.auth.isCompleteDecimal ? 6 : 2, this.props.currencyRate)
                /** Aviator顯示邏輯 */
                const extraBet = rowData.info?.is_extra_bet ? '★' : ''
                return this.state.BetFailed.includes(rowData.action) ? <div style={{ color: '#f00' }}>{`${display}${extraBet}`}</div> : `${display}${extraBet}`
            },
        },
        {
            field: 'bet_area',
            render: (rowData) => {
                if (rowData.action === 'bet' || rowData.action === 'cancel_bet') return utils.GetBetTypeGameAreaDisplay(this.state.gameCode, rowData['info']['bet_area_index'])
                else if (rowData.action === 'rebet')
                    return Object.entries(rowData['info']['area_bet'])
                        .filter(([_, money]) => money > 0)
                        .map(([betAreaIdx, _]) => utils.GetBetTypeGameAreaDisplay(this.state.gameCode, betAreaIdx))
                        .join(', ')

                return ''
            },
        },
    ]

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {}

    OpenDialog(inputs) {
        this.reset()
        this.queryContent(inputs)
        this.setState({ dialogOpen: true })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    queryContent(inputs) {
        setTimeout(() => this.table.SetLoading(true))
        
        utils.apiRequest(
            'get',
            API.PLAYER_USER_ACTION_LOG,
            inputs,
            (data) => {
                this.setState({ gameCode: data.game_code })

                try {
                    const actions = JSON.parse(data.actions)
                    if (Array.isArray(actions)) {
                        this.table.SetData(
                            actions.filter((elem) => {
                                if (this.state.BetFailed.includes(elem.action) && elem.action !== 'cancel_bet') {
                                    elem.time = ''
                                }
                                return this.state.validAction.includes(elem.action)
                            })
                        )
                    }
                    else this.table.SetData([])
                } catch (e) {
                    this.table.SetData([])
                }

                this.table.SetLoading(false)
            },
            (_err) => {
                this.table.SetData([])
                this.table.SetLoading(false)
            },
            true
        )
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} scroll="body">
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Table ownerName="UserActionLogDialog" columns={this.columns} onRef={(ref) => (this.table = ref)} />
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.setState({ dialogOpen: false })} color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

UserActionLogDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    currencyRate: PropTypes.number,
    auth: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(UserActionLogDialog)
